export const onlyNumbers = (value: string): string =>
  value.replace(/[^\d]/g, '');
